import { Component, OnInit, Input, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { InteractionsService } from 'src/app/services/interactions.service';
import { MethodsService } from 'src/app/services/methods.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import * as _ from 'lodash';

@Component({
  selector: 'app-crucintarsio',
  templateUrl: './crucintarsio.component.html',
  styleUrls: ['./crucintarsio.component.scss']
})
export class CrucintarsioComponent implements OnInit, OnDestroy {

  @Input('interactionId') interactionId;
  private interaction;
  public soluzione;
  private interactionsSubscriber;

  @ViewChild('player_container') playerContainer;
  @ViewChild('answer') inputAnswer: ElementRef;

  form = new FormGroup({
    answer: new FormControl('', Validators.minLength(5)),
  });

  selectDirection = false;
  lettersTable;
  questions;
  selectedQuestion = '';
  direction;
  questionNumber;
  error = false;
  success = false;

  completed ;

  selectedAnswer;
  userAnswer;


  intersecQuestionH;
  intersecQuestionV;
  intersecWordV;
  intersecWordH;


  showSolutions = false;

  constructor(
    private interactionsService: InteractionsService,
    private methods: MethodsService
  ) { }

  ngOnInit(): void {
    this.interactionsSubscriber = this.interactionsService.interactions$.subscribe(interactions => {
      this.interaction = interactions.filter(interaction => interaction.id === this.interactionId)[0];
      this.methods.get('assets/data/' + this.interaction.content.configId + '.config.json').subscribe( config => {
        this.lettersTable = config.grid;
        this.questions = config.questions;
        console.log('lung', this.getSize(this.questions));
        this.completed = 0;
        this.soluzione = config.soluzione;
        if (this.interaction.completed.onComplete) {
          this.showAll();
          this.completed = this.getSize(this.questions);
        }
      });
    });
  }

  getSize(obj) {
    let size = 0;
    let key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) {size++; }
    }
    return size;
}

  onLetterSelection(letter, wordH, wordV, questionH, questionV) {
    this.scroll();
    if (questionH && questionV) {
      this.questionNumber = '';
      this.direction = '';
      this.selectDirection = true;
      this.intersecQuestionH = questionH;
      this.intersecQuestionV = questionV;
      this.intersecWordV = wordV;
      this.intersecWordH = wordH;

    } else if (questionH && !questionV) {
      this.questionNumber = questionH;
      this.selectedAnswer = wordH;
      this.direction = 'h';
      this.findQuestion(questionH);

    } else if (!questionH && questionV) {
      this.questionNumber = questionV;
      this.selectedAnswer = wordV;
      this.direction = 'v';
      this.findQuestion(questionV);
    }
    setTimeout(() => this.inputAnswer.nativeElement.focus());
  }


  findQuestion(questionId) {
    const questionIndex = _.findIndex(this.questions, questionId);
    this.selectedQuestion = this.questions[questionId];
  }

  getAnswer() {
    this.userAnswer = this.form.get('answer').value;
    if (this.userAnswer.toLowerCase() === this.selectedAnswer.toLowerCase()) {
      this.setCorrectWord();
      this.success = true;

      this.setCorrectWord();
      setTimeout(() => {
        this.questionNumber = '';
        this.direction = '';
        this.selectedQuestion = '';
        this.success = false;
        this.completed++;
        this.form.setValue({answer: ''});
        if (this.completed >= this.getSize(this.questions)) {
          this.interaction.completed = {
            onComplete: true,
            status: 'success'
          };
          this.interactionsService.setCompleted(this.interaction);
          this.interactionsService.updateInteraction(this.interaction);
        }
      }, 1000);
    } else {
      this.error = true;
      setTimeout(() => {
        this.error = false;
        this.form.setValue({answer: ''});
      }, 1000);
    }
  }


  setCorrectWord() {
    this.lettersTable.forEach((row) => {
      row.celle.forEach((col) => {

        if (this.direction === 'h') {
          if (col.question && col.question.h === this.questionNumber) {
            col.guessed = true;
          }
        } else {
          if (col.question && col.question.v === this.questionNumber) {
            col.guessed = true;
          }
        }
      });
    });
  }

  setDirection(direction, question, word) {
    this.selectDirection = false;
    this.selectedAnswer = word;
    this.questionNumber = question;
    this.findQuestion(question);
    this.direction = direction;
  }

  scroll() {
    const el = document.getElementById('toScroll');
    el.scrollIntoView({block: 'end', behavior: 'smooth'});
  }

  showAll() {
    this.lettersTable.forEach((row) => {
      row.celle.forEach((col) => {
        col.guessed = true;
      });
    });
  }

  ngOnDestroy() {
    this.interactionsSubscriber.unsubscribe();
  }

}
